import React from "react";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { avatarCreater, searchHighlight, userStatusColor } from "../../../../base/callService/common";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";


export default function SpecificMemberLists(searchText: string, specificContacts: Array<any>, isExt?: any) {

    let len = Math.round((specificContacts?.length / 8));
    let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

    return (
        
                <>
                    {specificContacts?.map((contactName: any, index: any) => {
                        // let highlighted: any = searchHighlight(contactName, searchText);
                        let avatarFinder = avatarCreater(contactName);
                        return <option key={index} value={(isExt ? contactName.ext : contactName.sip_login_id)}>
                            <div className="dropdowndesign">
                                <URAvatarGroup className={`lefts size22 ${avatarFinder.size} colorBG${random_color[index]}`}
                                    profileInfo={
                                        ((contactName.ImageURL !== null && contactName.ImageURL !== "") &&
                                            (contactName.profile_image_url !== null && contactName.profile_image_url !== "")) ?
                                            (<>
                                                <img src={contactName.ImageURL ? contactName.ImageURL : contactName.profile_image_url} alt="" />
                                                {contactName.user_status &&
                                                    <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                                                }</>) :

                                            (<>
                                                <span>{(contactName?.caller_id).charAt(0).toUpperCase()} </span>
                                                {contactName.user_status &&
                                                    <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />}
                                            </>)
                                    } />

                                {/* <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                                    <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                                    {highlighted?.lastMsg}</>) :

                                    (<>{contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}</>)}</div> */}


                                <div className="names">{contactName?.caller_id ? contactName?.caller_id : contactName?.team_name}</div>


                                {contactName.ext && <div className="ext">{contactName.ext}</div>}
                            </div>
                        </option>;

                    })}
                </>

         

    );
};
